import { Pipe, PipeTransform } from '@angular/core';
import {DecimalPipe} from "@angular/common";

@Pipe({
	name: 'numberFormat'
})
export class NumberFormat extends DecimalPipe implements PipeTransform {
	transform(value: any, args?: any): any {
		let val = super.transform(value, args);
		
		return ('' + val).replace(/\,/g, ' ').replace(/\./, ',');
	}
}
